export enum OperationalPowerFields {
  minimalOperationalPower = "minimalOperationalPower",
  maximalOperationalPower = "maximalOperationalPower",
}

export enum FcrDEngagementFields {
  highDroop = "highDroop",
  lowDroop = "lowDroop",
  oneHourTestCapacity = "oneHourTestCapacity",
}
